/**
 * RefundListContainer
 * --
 */
import React from 'react';
import OrderList from 'routes/admin.routes/admin.orders/OrderList';

const RefundListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <OrderList purchaseStatus={['EXCHANGE_COMPLETED', 'RETURN_COMPLETED']} />
    </>
  );
};

export default RefundListContainer;
